import styled from '@emotion/styled'
import { hexColors } from '@mobi/settings'
import { InputField } from '@mobi/component-library/Common/Input/InputField'
import { DepositLimitComponentTheme } from '../../themes'
import { ButtonBlockStyled } from '@mobi/component-library/Common/Buttons'

interface Theme {
  theme?: DepositLimitComponentTheme
}

export const DepositLimitsContainerStyled = styled.div<Theme>(
  {
    boxSizing: 'border-box',
    height: '100%',
    textAlign: 'left',
  },
  ({ theme }) => ({
    fontSize: theme.container.text.size,
    padding: theme.container.padding,
    margin: theme.container.margin,
    width: theme.container.width,
  })
)

export const ViewTitleStyled = styled.div({
  padding: '1rem 0 0 0',
  color: hexColors.dimGrey,
})

export const ViewValueStyled = styled.div({
  padding: '0.5rem 0 0.75rem 0',
  fontSize: '1.8rem',
})

export const EditButtonContainer = styled.div({ margin: '3rem 0' })

export const FieldSetStyled = styled.fieldset({ borderStyle: 'none' })

export const OrderedListStyled = styled.ol({
  fontSize: 'inherit',
  listStyleType: 'none',
  padding: 0,
})

export const OrderedListItemStyled = styled.li<{ hasUnderline?: boolean }>(
  { margin: '0.5rem 0' },
  ({ hasUnderline }) => ({
    borderBottom: hasUnderline ? `1px solid ${hexColors.veryLightGrey}` : undefined,
  })
)

export const ListItemSubtitleStyled = styled.span<Theme>(
  { paddingLeft: '3rem', display: 'inline-block' },
  ({ theme }) => ({
    paddingLeft: theme.radio.paddingLeft,
  })
)

export const AmountInputStyled = styled(InputField)<Theme>(
  { fontWeight: 'bold', textAlign: 'left' },
  ({ theme }) => ({
    fontSize: theme.input.fontSize,
    padding: theme.input.padding,
  })
)

export const ButtonBlockThemed = styled(ButtonBlockStyled)<Theme>(({ theme }) => ({
  fontSize: theme.button.fontSize,
  height: theme.button.height,
}))
